/**
 * A tapped browser push lands on the app with ?mid=<send id> (services/api push/dispatch.ts). Report the open once (first-party,
 * POST /m/<id>/open; no cookie, no address) and take the id off the address so a reload does not count again. A failure is silent:
 * the person is already where they were going.
 */
import { messageIdFromQuery } from "@logwave/core";

export function captureMessageOpen(search: string, apiUrl: string, post: (url: string) => void = (u) => { void fetch(u, { method: "POST", keepalive: true }).catch(() => undefined); }): string | null {
  const { id } = messageIdFromQuery(search);
  if (id) post(`${apiUrl}/m/${id}/open`);
  return id;
}
export const withoutMessageParam = (search: string): string => messageIdFromQuery(search).rest;
